import { render } from "./MobileFeatured.vue?vue&type=template&id=39d2cee8&scoped=true"
import script from "./MobileFeatured.vue?vue&type=script&lang=js"
export * from "./MobileFeatured.vue?vue&type=script&lang=js"

import "./MobileFeatured.vue?vue&type=style&index=0&id=39d2cee8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39d2cee8"

export default script